import React from 'react';
import Header from './Header';
import Footer from './Footer';

const LegalPage = () => {
    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <Header />
            <main className="flex-grow max-w-4xl mx-auto px-4 py-12">
                <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12">
                    <h1 className="text-3xl font-bold text-gray-900 mb-8">Mentions Légales</h1>

                    <div className="prose prose-purple max-w-none text-gray-600">
                        <section className="mb-8">
                            <h2 className="text-xl font-semibold text-gray-900 mb-4">Éditeur du site</h2>
                            <p className="mb-2">
                                Ce site est édité par :
                            </p>
                            <p className="font-medium text-gray-900">
                                Didier Nactergal IT Consultant
                            </p>
                            <p>
                                rue de Maréchal de Saint-André<br />
                                Mariembourg<br />
                                Belgique
                            </p>
                            <p className="mt-2">
                                Téléphone : 0475 36 77 17<br />
                                Email : contact@linkoo.be
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-xl font-semibold text-gray-900 mb-4">Hébergement</h2>
                            <p>
                                Ce site est hébergé par :<br />
                                [Nom de l'hébergeur]<br />
                                [Adresse de l'hébergeur]<br />
                                [Site web de l'hébergeur]
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-xl font-semibold text-gray-900 mb-4">Propriété intellectuelle</h2>
                            <p>
                                L'ensemble de ce site relève de la législation belge et internationale sur le droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
                            </p>
                        </section>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default LegalPage;
